// Tipos para o Cadastro de Componentes N1

export interface IComponente {
  idComponente?: number;
  codigo: string;
  codigoInterno?: string;
  descricao: string;
  idSituacao: number;
  idStatus: number;
  idReferencia?: number;
  idLinha?: number;
  idGrupo?: number;
  
  // Aplicação e Cor (Regra Condicional)
  aplicacao: 'cor_unica' | 'colorido'; // Obrigatório
  idCor?: number; // Obrigatório quando aplicacao = 'cor_unica'
  corDescricao?: string;
  
  // Unidades e Quantidades
  idUnidadeItem: number; // Obrigatório
  idUnidadeEmbalagem: number; // Obrigatório
  quantidadeEmbalagem: number; // Obrigatório, integer >= 1
  loteMinimoQtdEmbalagens: number; // Obrigatório, integer 1-99999
  
  // Otimização
  otimizacaoBarra?: string;
  
  // Mídia
  imagemUrl?: string;
  imagemNomeArquivo?: string;
  // FASE 05 — 2ª validação/PO 2026-07-24 (D2): ícone (.bmp) e ficha técnica (.pdf/.jpg).
  iconeUrl?: string;
  iconeNomeArquivo?: string;
  fichaTecnicaUrl?: string;
  fichaTecnicaNomeArquivo?: string;

  // Cores (quando aplicacao = 'colorido')
  cores?: IComponenteCor[];
  
  // Auditoria
  dataUltimaAtualizacao?: string;
  dataCriacao?: string;
  editavel?: boolean;
  excluido?: boolean;
}

export interface IComponenteCor {
  id?: number;
  ordem: number; // Sequência (1, 2, 3, ...)
  idCor: number; // Obrigatório
  corDescricao: string; // Ex: "BRANCO", "PRETO"
  codigoProduto?: string; // Opcional - Código específico por cor
  idComponente?: number; // FK para Componente
}

// Opções de Situação
// FASE 05 — 4ª validação/D3 2026-07-30: semântica legada — 3 = Disponível mercado,
// 4 = Indisponível (fora do fluxo), 5 = Homologado (estado novo do fluxo).
export const SITUACAO_OPTIONS = [
  { id: 1, label: 'Em edição' },
  { id: 2, label: 'Em homologação' },
  { id: 3, label: 'Disponível mercado' },
  { id: 4, label: 'Indisponível' },
  { id: 5, label: 'Homologado' },
];

// Opções de Status
export const STATUS_OPTIONS = [
  { id: 1, label: 'Ativo' },
  { id: 2, label: 'Descontinuado' },
  // FASE 05 — 2ª validação/PO 2026-07-24 (Frente 7, P5): "Inativo" removido do front.
];

// Opções de Aplicação
export const APLICACAO_OPTIONS = [
  { value: 'cor_unica', label: 'Cor única' },
  { value: 'colorido', label: 'Colorido' },
];

// Interface para selects de referência
export interface ISelectOption {
  id: number;
  nome: string;
  descricao?: string;
}

// Tab index
export type ComponenteTabIndex = 0 | 1;
export const COMPONENTE_TABS = ['GERAL', 'CORES'] as const;
